import React, { Component } from 'react';
import { Layout, Input, Button, message, Icon, Select, Spin, Popover } from 'antd';
import { Parse } from 'parse';
import { FormattedMessage, FormattedHTMLMessage, defineMessages,   injectIntl } from 'react-intl';

import MypageNav from '../../components/navigation/MypageNav';
import Headline from '../../components/Headline';
import { notiFormForError } from '../../components/notificationForm';
import ReusableCountrySelect from '../../components/ReusableCountrySelect';
import UrlPreviewViewer from '../../components/UrlPreviewViewer';
import { getSNSIconComponent } from '../../utils/getSNSIconComponent';
import { processAnFetchData } from '../../utils/errorHandling';
import '../../styles/Mypage.css';

const { Content } = Layout;
const userQuery = new Parse.Query(Parse.Object.extend('User'));
const countries = require('country-data').countries;

const messages = defineMessages({
  nicknameMinLength: {
    id: 'Signup.nickname.error.minLength',
    defaultMessage: 'Nickname must be at least 3 characters',
  },
  nicknameMaxLength: {
    id: 'Signup.nickname.error.maxLength',
    defaultMessage: 'Nickname cannot have more than 20 characters',
  },
  nicknameFormat: {
    id: 'Signup.nickname.error.foramt',
    defaultMessage: 'Nickname must be registered in English, numbers, and special characters.',
  },
  nicknameOverlap:{
    id:'Signup.nickname.error.overlap',
    defaultMessage:'This nickname has already been used.'
  },
  okText: {
    id: 'Popconfirm.okText.ok',
    defaultMessage: 'OK',
  },
  cancelText: {
    id: 'Popconfirm.cancelText',
    defaultMessage: 'Cancel',
  },
});

class Setting extends Component {
  constructor(props) {
    super(props);
    const user = Parse.User.current();

    this.state = {
      spinning: true,
      userInfo: {
        email: user.get('email'),
        userName: user.get('nickname'),
        country: user.get('country'),
        commenderCode: user.get('commendercode'),
      },
      inputSuffixUrl: null,
      snsInfos: [],
      selectedSNS: {
        snsName: 'instagram',
        prefixUrl: 'instagram.com',
      },
      visibleUrlCheckBox: false,
      isValidUrl: false,
    };
  }

  async componentDidMount() {
    try {
      const snsList = await new Parse.Query(Parse.Object.extend('SNS')).find().then((snss) =>
        snss.map((sns) => ({
          sns: sns,
          snsName: sns.get('name').toLowerCase(),
          prefixUrl: sns.get('linkUrlPrefix'),
        })),
      );

      const creatorSNS = await new Parse.Query(Parse.Object.extend('CreatorSNS'))
        .equalTo('creator', Parse.User.current())
        .include('sns')
        .first();

      this.setState({
        spinning: false,
        snsInfos: snsList,
        isValidUrl: creatorSNS ? true : false,
        inputSuffixUrl: creatorSNS ? creatorSNS.get('linkUrlSuffix') : '',
        selectedSNS: creatorSNS
          ? {
              snsName: creatorSNS
                .get('sns')
                .get('name')
                .toLowerCase(),
              prefixUrl: creatorSNS.get('sns').get('linkUrlPrefix'),
            }
          : {
              snsName: 'instagram',
              prefixUrl: 'instagram.com',
            },
      });
    } catch (err) {
      this.setState({ spinning: false });
      processAnFetchData(err);
    }
  }

  render() {
    const { formatMessage, locale } = this.props.intl;
    const { userInfo, snsInfos, selectedSNS, spinning, inputSuffixUrl, visibleUrlCheckBox, isValidUrl } = this.state;
    return (
      <Spin spinning={spinning} tip="Loading...">
        <Layout style={{ background: '#fff', height: 'inherit' }}>
          <MypageNav selectedKey={'setting'} />
          <Content style={{ margin: 20 }}>
            <Headline id="Mypage.setting.headline" defaultMessage="Setting" />
            <div style={{ margin: '0px 25px' }}>
              <div className="mypage-subtitle" style={{ marginTop: 5 }}>
                <FormattedMessage id={'Mypage.setting.subTitle.email'} defaultMessage={'Email'} />
              </div>
              <p className="mypage-email">{userInfo.email}</p>
              <div className="mypage-subtitle">
                <FormattedMessage id={'Mypage.setting.subTitle.name'} defaultMessage={'Name/Nickname'} />
              </div>
              <Input className="input-nickname" type="text" value={userInfo.userName.en} onChange={this.handleNicknameChange} />
              <div className="mypage-subtitle">
                <FormattedMessage id={'Mypage.setting.subTitle.country'} defaultMessage={'Choose a Country'} />
              </div>
              <ReusableCountrySelect
                countries={countries.all}
                placeholder="Please select a country"
                className="setting-country"
                onSelect={this.handleCountrySelect}
                showSearch={true}
                value={userInfo.country}
              />
              {/*
              <p className="mypage-subtitle">
                <FormattedMessage
                  id={'Mypage.setting.subTitle.commenderCode'}
                  defaultMessage={'Commender Code'}
                />
              </p>
              <Input className="input-nickname" type="text" value={this.state.userInfo.commenderCode} onChange={this.handleCommenderCodeChange} style={{backgroundColor:' rgba(95, 255, 175, 0.1)'}}/>
             */}

              <div className="mypage-subtitle">
                <FormattedMessage id="Mypage.setting.subTitle.sns" defaultMessage="Add a Website" />
              </div>
              <div className="mypage-description">
                <FormattedHTMLMessage
                  id="Mypage.setting.descriptoin.sns"
                  defaultMessage="Please add some sites to show your artworks<br/><br/><p>*</p>Channels that are not related to creative activities may not be shown."
                />
              </div>
              <div className="setting-sns-wrapper">
                <Select value={selectedSNS.snsName} className="sns-select" onChange={(e) => this.changeSNSChannel(e)}>
                  {snsInfos.map((snsInfo) => (
                    <Select.Option key={snsInfo.snsName} className="sns-select-option">
                      {<Icon component={getSNSIconComponent(snsInfo.snsName)} style={{ width: 16, marginRight: 16 }} />}
                      {snsInfo.snsName}
                    </Select.Option>
                  ))}
                </Select>
                <Input
                  className="sns-input"
                  defaultValue={inputSuffixUrl}
                  value={inputSuffixUrl}
                  onChange={(e) => this.setState({ inputSuffixUrl: e.target.value })}
                  addonBefore={
                    <div className="sns-input-prefix">
                      <Icon type="link" />
                      <p>{selectedSNS.prefixUrl.replace('https://', '').replace('www.', '') + '/'}</p>
                    </div>
                  }
                />
                {/* <Popover
                  trigger="click"
                  placement="bottomRight"
                  className="sns-url-check-box"
                  visible={visibleUrlCheckBox}
                  onVisibleChange={(visible) => this.setState({ visibleUrlCheckBox: visible })}
                  content={
                    <UrlPreviewViewer
                      url={selectedSNS.prefixUrl + '/' + inputSuffixUrl}
                      onCancel={() => this.setState({ inputSuffixUrl: '' })}
                      okText={formatMessage(messages.okText)}
                      cancelText={formatMessage(messages.cancelText)}
                      onCheckValidUrl={(valid) => this.setState({ isValidUrl: valid })}
                      onVisibleChange={() => this.setState({ visibleUrlCheckBox: false })}
                      locale={locale}
                    />
                  }>
                  <Button
                    disabled={inputSuffixUrl ? false : true}
                    onClick={() => this.setState({ visibleUrlCheckBox: true })}
                    type="primary"
                    icon="search"
                  />
                </Popover> */}
              </div>

              {/* <div className="setting-btn-wrapper">
                {!isValidUrl && inputSuffixUrl !== '' ? (
                  <div>
                    <FormattedMessage id="Mypage.setting.validUrl.error" defaultMessage="This website is not valid." />
                  </div>
                ) : null}
                <Button onClick={this.handleUpdateUserInfo} className="btn-style-primary" disabled={!isValidUrl && inputSuffixUrl !== ''}>
                  <FormattedMessage id={'Mypage.setting.btn'} defaultMessage={'Save'} />
                </Button>
              </div> */}
              <div>
                <Button onClick={this.handleUpdateUserInfo} className="btn-style-primary setting-btn">
                  <FormattedMessage id={'Mypage.setting.btn'} defaultMessage={'Save'} />
                </Button>
              </div>
            </div>
          </Content>
        </Layout>
      </Spin>
    );
  }

  handleCommenderCodeChange = (e) => {
    this.setState({
      userInfo: {
        ...this.state.userInfo,
        commenderCode: e.target.value,
      },
    });
  };
  handleNicknameChange = (e) => {
    this.setState({
      userInfo: {
        ...this.state.userInfo,
        userName: {
          ko: e.target.value,
          en: e.target.value,
        },
      },
    });
  };

  handleCountrySelect = (value) => {
    this.setState({
      userInfo: {
        ...this.state.userInfo,
        country: value,
      },
    });
  };

  handleUpdateUserInfo = () => {
    const { formatMessage, locale } = this.props.intl;
    const { userInfo, inputSuffixUrl, selectedSNS, snsInfos } = this.state;

    if (userInfo.userName.en.length < 3) {
      notiFormForError(locale, formatMessage(messages.nicknameMinLength));
    } else if (userInfo.userName.en.length > 20) {
      notiFormForError(locale, formatMessage(messages.nicknameMaxLength));
    } else if (userInfo.userName.en.match(/([^a-zA-Z0-9,./?~`!@#${}%^&*()-_=+'"‘“’”|<>\s])|(^\s)|(\s$)/) !== null) {
      notiFormForError(locale, formatMessage(messages.nicknameFormat));
    } else {
      this.setState({ spinning: true }, async () => {
        let user = null;
        try {
          user = await userQuery.get(Parse.User.current().id);
          
          user.set('nickname', userInfo.userName);
          user.set('country', userInfo.country);
          await user.save();

          const creatorSNS = await new Parse.Query(Parse.Object.extend('CreatorSNS')).equalTo('creator', Parse.User.current()).first();

          const selectedSNSInfo = snsInfos.find((info) => info.snsName === selectedSNS.snsName);

          if (creatorSNS) {
            if (inputSuffixUrl === '') {
              //입력한 sns 주소 없을 경우 creatorSNS가 있다면 삭제해야됨
              await creatorSNS.destroy();
            } else {
              await creatorSNS
                .set({
                  sns: selectedSNSInfo.sns,
                  linkUrlSuffix: inputSuffixUrl,
                })
                .save();
            }
          } else if (!creatorSNS && inputSuffixUrl !== '') {
            await new Parse.Object('CreatorSNS')
              .set({
                sns: selectedSNSInfo.sns,
                order: 1,
                linkUrlSuffix: inputSuffixUrl,
                creator: user,
              })
              .save();
          }

          this.setState({ spinning: false });

          message.success('Success!');
        } catch (err) {
          this.setState({ spinning: false });
          if (err.code === 1100){//닉네임이 중복일 경우
            user && user.revert();
            notiFormForError(this.props.intl.locale, formatMessage(messages.nicknameOverlap));
            return;
          } 
          message.error('Failed to save information. Please try again.🙏');
        }
      }
      );
    }
  };

  changeSNSChannel = (snsName) => {
    const selectedSNS = this.state.snsInfos.find((info) => info.snsName === snsName);
    this.setState({ selectedSNS });
  };
}
 
Setting = injectIntl(Setting);

export default Setting;
